import * as React from 'react';

export class Header extends React.Component<any, any> {
    
  constructor(props: any) {
    super(props);
  }

  public render() {

    let header:JSX.Element =      
        <header className="ms-u-textAlignCenter ms-u-slideDownIn20 anim-1 anim-delay-05">
          <h1><span className="ms-font-su">Welcome to the <strong>Journey Designer</strong>.</span></h1>
        </header>;

    return header;

  }

}


// WEBPACK FOOTER //
// ./source/ts/components/layout/header.tsx